import { RenderMode, RenderModeString } from '../../../../library/renderModes';

export type LayoutPolygonVisualMode = 'solid' | 'wireframe' | 'translucent';

export function layoutPolygonVisualModeIsSelectable(
  mode: RenderModeString<RenderMode<LayoutPolygonVisualMode>>,
): boolean {
  return !(mode === 'none' || mode === 'wireframe');
}
